var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWallet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.9375 4.6875H5.0625C4.44023 4.6875 3.9375 5.19023 3.9375 5.8125V31.6875C3.9375 32.3098 4.44023 32.8125 5.0625 32.8125H30.9375C31.5598 32.8125 32.0625 32.3098 32.0625 31.6875V5.8125C32.0625 5.19023 31.5598 4.6875 30.9375 4.6875ZM29.8125 21H18.5625V16.5H29.8125V21ZM20.3906 18.75C20.3906 19.123 20.5388 19.4806 20.8025 19.7444C21.0662 20.0081 21.4239 20.1562 21.7969 20.1562C22.1698 20.1562 22.5275 20.0081 22.7912 19.7444C23.055 19.4806 23.2031 19.123 23.2031 18.75C23.2031 18.377 23.055 18.0194 22.7912 17.7556C22.5275 17.4919 22.1698 17.3438 21.7969 17.3438C21.4239 17.3438 21.0662 17.4919 20.8025 17.7556C20.5388 18.0194 20.3906 18.377 20.3906 18.75Z",
    fill: "#FFD37E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/Wallet.5ab407e4575e7a8b18261de37684c659.svg";
export { ForwardRef as ReactComponent };